module.exports = __webpack_public_path__ + "static/cliente_14-cb9a7e31667f618e4788ac4a45c21d1b.png";